import { tableCapacityForTierId } from "./table";

/**
 * The guest step's own cart: what the buyer pays for once guests are named.
 *
 * An ordinary tier is counted by the guests named on it, because each of those
 * tickets must be issued to someone. A table is a package bought whole and
 * named later on the roster screen, so its line always comes from the booking
 * cart and naming or moving a guest never changes it.
 */

export const cartLineFor = (ticket, quantity) => ({
  label: ticket.name,
  value: ticket.id,
  ticketTier: ticket.ticketTier,
  price: ticket.price,
  tableCapacity: ticket.tableCapacity,
  currency: ticket.currency,
  name: ticket.name,
  quantity,
});

export const withTableLines = (guestCart, cart, tierList) => {
  const next = { ...guestCart };
  for (const tierId in cart) {
    if (tableCapacityForTierId(tierId, tierList)) {
      next[tierId] = cartLineFor(cart[tierId], cart[tierId].quantity);
    }
  }
  return next;
};

const isTable = (ticket, tierList) =>
  Boolean(tableCapacityForTierId(ticket.ticketTier, tierList));

const withoutOneGuest = (guestCart, ticket) => {
  const line = guestCart[ticket.ticketTier];
  if (!line) return guestCart;
  const next = { ...guestCart };
  if (line.quantity === 1) {
    delete next[ticket.ticketTier];
  } else {
    next[ticket.ticketTier] = { ...line, quantity: line.quantity - 1 };
  }
  return next;
};

const withOneGuest = (guestCart, ticket) => {
  const line = guestCart[ticket.ticketTier];
  return {
    ...guestCart,
    [ticket.ticketTier]: line?.quantity
      ? { ...line, quantity: line.quantity + 1 }
      : { ...ticket, quantity: 1 },
  };
};

/** The guest cart after a guest's ticket changes from `previous` to `next`. */
export const withGuestTicketChange = (guestCart, previous, next, tierList) => {
  let result = guestCart;
  if (previous && !isTable(previous, tierList)) {
    result = withoutOneGuest(result, previous);
  }
  if (next && !isTable(next, tierList)) {
    result = withOneGuest(result, next);
  }
  return result;
};
